<template>
    <div>
        <!-- 담당자명 -->
        <InputTitle
            v-model="column.title"
            :isErrorTitle="isErrorTitle"
            :isErrorDuplicatedTitle="isErrorDuplicatedTitle"
            @clearError="handleClearError"
        />
        <!-- 예약 알림받을 계정 -->
        <NotificationUser
            v-model="column.notificationUsers"
            :users="users"
            :isShowList="isShowNotificationUserList"
            @updateVisible="handlerSelectBoxVisible"
        />
        <!-- 직원 연결 -->
        <Employee
            v-model="column.employeeID"
            :employees="employees"
            @updateValue="handleUpdateValue"
        />
        <!-- 프로그램 선택 -->
        <Programs
            :programs="programs"
            :selectedProgramIDs="column.programs"
            :selectedAppProgramIDs="column.appPrograms"
            :isErrorSelectedProgram="isErrorSelectedProgram"
            :isShowList="isShowProgramList"
            @updateValue="handleUpdateValue"
            @updateVisible="handlerSelectBoxVisible"
            @clearError="handleClearError"
        />
        <!-- 굵은선 표기 -->
        <BoldLineConfig
            :usingDefaultBoldInterval="column.usingDefaultBoldInterval"
            :boldInterval="column.boldInterval"
            :boldTimeIntervals="column.boldTimeIntervals"
            :isErrorBoldTime="isErrorBoldTime"
            :isErrorDuplicatedBoldTime="isErrorDuplicatedBoldTime"
            @updateValue="handleUpdateValue"
            @clearError="handleClearError"
        />
    </div>
</template>
<script>
import InputTitle from './Components/InputColumnTitle.vue'
import NotificationUser from './Components/NotificationUser.vue'
import Employee from './Components/Employee.vue'
import Programs from './Components/Programs.vue'
import BoldLineConfig from './Components/BoldLineConfig.vue'

export default {
    components: { Programs, Employee, NotificationUser, InputTitle, BoldLineConfig },
    props: {
        column: Object,
        users: Array,
        programs: Array,
        employees: Array,

        isErrorTitle: Boolean,
        isErrorDuplicatedTitle: Boolean,
        isErrorSelectedProgram: Boolean,
        isErrorBoldTime: Boolean,
        isErrorDuplicatedBoldTime: Boolean,
    },
    data() {
        return {
            isShowNotificationUserList: false,
            isShowProgramList: false
        }
    },
    methods: {
        handlerSelectBoxVisible(data) {
            switch (data.key) {
                case 'notification': {
                    this.isShowProgramList = false
                    this.isShowNotificationUserList = data.value
                    break
                }
                case 'program': {
                    this.isShowNotificationUserList = false
                    this.isShowProgramList = data.value
                    break
                }
            }
        },
        handleClearError(errorName) {
            this.$emit('clearError', errorName)
        },
        handleUpdateValue(data) {
            this.$emit('updateValue', data)
        }
    }
}
</script>
